module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="ngeo-streetview-instructions" ng-if="$ctrl.location === null" translate>\n  Click on a road on the map to start StreetView.\n</div>\n<div\n  class="ngeo-streetview-nodata"\n  ng-if="$ctrl.streetViewService_.noDataAtLocation && $ctrl.location !== null"\n  translate\n>\n  Street View data not found for this location.\n</div>\n<div ng-if="$ctrl.viewer === \'mapillary\'" id="mly" style="width: 100%; height: 100%"></div>\n';

}
return __p
}